import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M10.9389 12.111L15.8889 17.061L14.4749 18.475L8.11092 12.111L14.4749 5.74698L15.8889 7.16098L10.9389 12.111Z" />,
  'ArrowLeftSLine'
);
